var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.8 0.826h-25.5c-3.02 0-5.46 2.45-5.46 5.46v24.9c0 3.02 2.45 5.46 5.46 5.46h25.5c3.02 0 5.46-2.45 5.46-5.46v-24.9c0-3.02-2.45-5.46-5.46-5.46z",
    fill: "#F3F3F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 39.7 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.08 40.2c-1.29 0-2.34-1.05-2.34-2.34v-28.3c0-1.29 1.05-2.34 2.34-2.34h22.9c0.786 0 1.54 0.312 2.1 0.868 0.556 0.556 0.868 1.31 0.868 2.1v27.1c0 0.786-0.312 1.54-0.868 2.1s-1.31 0.868-2.1 0.868z",
    fill: "#e30917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.51 16.7v13.8c0 0.779 0.632 1.41 1.41 1.41h1.66c0.779 0 1.41-0.631 1.41-1.41v-13.8c0-0.779-0.632-1.41-1.41-1.41h-1.66c-0.779 0-1.41 0.632-1.41 1.41z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9 23.8c0 0.157-0.0624 0.308-0.174 0.419-0.111 0.111-0.262 0.174-0.419 0.174h-9.23c-0.157 0-0.308-0.0624-0.419-0.174-0.111-0.111-0.174-0.262-0.174-0.419s0.0624-0.308 0.174-0.419c0.111-0.111 0.262-0.174 0.419-0.174h9.23c0.157 0 0.308 0.0624 0.419 0.174 0.111 0.111 0.174 0.262 0.174 0.419z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.9 23.8c0.0019 0.0796-0.013 0.159-0.0436 0.232s-0.0763 0.14-0.134 0.194l-4.01 3.75c-0.0551 0.0555-0.121 0.0996-0.193 0.13-0.0722 0.03-0.15 0.0455-0.228 0.0455-0.0782 0-0.156-0.0155-0.228-0.0455-0.0722-0.0301-0.138-0.0742-0.193-0.13-0.109-0.113-0.17-0.264-0.17-0.421s0.0611-0.308 0.17-0.421l3.56-3.31-3.56-3.33c-0.0893-0.112-0.135-0.252-0.13-0.395 0.0059-0.143 0.0632-0.279 0.161-0.383 0.0982-0.104 0.231-0.169 0.373-0.183 0.142-0.014 0.285 0.0239 0.401 0.107l4.01 3.75c0.0613 0.0516 0.112 0.115 0.148 0.186s0.0587 0.149 0.065 0.229z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.aa3305e77a788dd297b4b8d699bfbb65.svg";
export { ForwardRef as ReactComponent };